module.exports = __webpack_require__.p + "d87f8f4f668b9e3a221987e433202d36.jpg";